module.exports = __webpack_public_path__ + "img/david-smc.93cd59ce.jpg";